import { render, staticRenderFns } from "./ContactInfoList.vue?vue&type=template&id=bf32d84c&scoped=true&"
import script from "./ContactInfoList.vue?vue&type=script&lang=ts&"
export * from "./ContactInfoList.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInfoList.vue?vue&type=style&index=0&id=bf32d84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32d84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
